import React from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from './propTypes/academyConfig';

export default function Clients({ academyConfig }) {
  const clients = academyConfig?.clients || [];

  return (
    <div className="landing-clients-container">
      <hr />
      <div className="landing-clients-row">
        {clients.slice(0, 5).map(client => (
          <a
            key={client.link}
            href={client.link}
            className="landing-client"
          >
            <img src={client.image} alt={client.name} />
          </a>
        ))}
      </div>
    </div>
  );
}

Clients.propTypes = {
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};
